import { html } from 'fxjs/es';
import { pipe, map, toArray, join } from '@fxts/core';
import { MShopAppSolutionCertTmplS } from '../../../Cert/S/Tmpl/module/MShopAppSolutionCertTmplS.js';
import { MShopAppSolutionHomeTmplS } from '../../../Home/S/Tmpl/module/MShopAppSolutionHomeTmplS.js';
import { preventEscape } from '@services/MarppleShop/shared/util/preventEscape.ts';
import { font } from '@services/MarppleShop/shared/typography/index.ts';
import { UtilS } from '@modules/Util/S/Function/module/UtilS.js';
import { makeMainUrl } from '@services/MarppleShop/shared/util/url.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr.ts';

export const makeSolutionTargetHtml = ({ reported_target }) => {
  const { reported_product, reported_design, reported_store } = reported_target;
  const makeCommonSolutionTargetHtml = (...reported_target_infos) => {
    return html`
      <div class="article">
        <div class="article__title">
          <h2>${T('report::신고 대상 정보')}</h2>
        </div>
        <div class="article__solution--target">
          ${pipe(
            reported_target_infos,
            map(
              ([label, text]) => html`
                <div class="article__solution--target__item ${font('16_regular')}">
                  <div class="article__solution--target__item--left">
                    <span>${label}</span>
                  </div>
                  <div class="article__solution--target__item--right">
                    <span>${text}</span>
                  </div>
                </div>
              `,
            ),
            toArray,
            join(''),
          )}
        </div>
      </div>
    `;
  };

  return UtilS.htmlIf2(
    UtilS.isMarppleShopApp() && !(reported_product && reported_design) && reported_store,
    () =>
      UtilS.htmlIf2(
        reported_product,
        () =>
          makeCommonSolutionTargetHtml(
            [T('report::크리에이터샵 주소'), makeMainUrl(`/${ET.lang}/${reported_store.domain_name}`)],
            [
              T('report::신고 상품 주소'),
              makeMainUrl(`/${ET.lang}/${reported_store.domain_name}/products/${reported_product.id}`),
            ],
          ),
        () =>
          makeCommonSolutionTargetHtml(
            [T('report::크리에이터'), reported_store.name],
            [T('report::상품 정보'), reported_design.name],
          ),
      ),
  );
};

export const fn = ({ reported_target }) =>
  MShopAppSolutionHomeTmplS.wrapper(
    'add',
    html`
      <div data-fx-json="${dataStr(reported_target)}" class="request-of-solution-add">
        <div class="article">
          <div class="article__title">
            <h2>${T('report::신고 접수 서비스 안내')}</h2>
          </div>
          <ul class="article__list">
            ${pipe(
              [
                T('report::신고 내용은 판매자에게 바로 전달됩니다.'),
                T('report::판매자의 답변 및 판매중지/재개 여부는 1:1 스레드에서 확인 가능합니다.'),
              ],
              map(
                (text) => html`
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">${preventEscape(text)}</p>
                  </li>
                `,
              ),
              toArray,
              join(''),
            )}
          </ul>
          <a class="article__link" href="/${ET.lang}/@/solution">${T('report::신고 서비스 자세히 보기')}</a>
          <div class="article__divider"></div>
        </div>
        ${makeSolutionTargetHtml({ reported_target })}
        <div class="add-type article" data-key="type">
          <div class="article__sub--title">
            <h2>${T('report::1. 신고 접수 유형 선택')}</h2>
          </div>
          <ul class="select">
            ${pipe(
              [
                [
                  'copyright',
                  T('report::저작권 침해'),
                  T('report::고객님의 작품, 콘텐츠 등을 침해한 상품 관련'),
                ],
                ['fake-product', T('report::위조상품 판매'), T('report::상표권/디자인권 침해 상품 관련')],
                [
                  'adult-regulation',
                  T('report::성인 인증 규정 위반'),
                  T('report::성인 인증 없이 판매되거나'),
                ],
                [
                  'internal-regulation',
                  T('report::마플샵 내부 규정 위반'),
                  T('report::연령제한, 타인 명의로 운영 중인 샵 관련'),
                ],
              ],
              map(
                ([value, label, description]) => html`
                  <li data-value="${value}">
                    <div class="type-selector"><div class="is_check"></div></div>
                    <div class="type-label">
                      <p class="${font('16_regular')}">${label}</p>
                      <span class="${font('12_regular')}"> ${description} </span>
                    </div>
                  </li>
                `,
              ),
              toArray,
              join(''),
            )}
          </ul>
        </div>
        <div class="add-user-type article" data-key="user_type">
          <div class="article__sub--title">
            <h2>${T('report::2. 권리 침해를 받은 당사자 선택')}</h2>
          </div>
          <ul class="select">
            ${pipe(
              [
                ['group', T('report::단체'), T('report::기업, 사업체, 종교단체, 학교 등')],
                ['person', T('report::개인'), T('report::본인, 가족, 친척, 지인 등')],
              ],
              map(
                ([value, label, description]) => html`
                  <li data-value="${value}">
                    <div class="type-selector"><div class="is_check"></div></div>
                    <div class="type-label">
                      <p class="${font('16_regular')}">${label}</p>
                      <span class="${font('12_regular')}"> ${description} </span>
                    </div>
                  </li>
                `,
              ),
              toArray,
              join(''),
            )}
          </ul>
        </div>
        <div class="add-agree-type article" data-key="agree_type">
          <div class="article__sub--title">
            <h2>${T('report::3. 필요 서류 안내 및 구비 여부 선택')}</h2>
            <p>
              ${T(
                'report::신고 접수 시 접수 유형과 당사자 선택에 따라 필요 서류가 달라지며 서류 구비가 되지 않은 경우, 신고 접수가 진행되지 않습니다.',
              )}
            </p>
          </div>
          <div class="agree-box" id="agree_box">
            <div class="info copyright">
              <h5>${T('report::① 저작권 침해 (고객님의 작품, 컨텐츠 등을 침해한 상품 관련)')}</h5>
              <div class="note">
                <ul class="article__list">
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T('report::해당 셀러의 저작권 침해 사실을 증빙할 수 있는 자료 첨부')}
                    </p>
                  </li>
                  <li class="group-li">
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T('report::기업/단체인 경우 사업자등록증, 법인등록증 사본 1부 첨부')}
                    </p>
                  </li>
                  <li class="group-li">
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T(
                        'report::접수자가 단체 대표자가 아닌 경우, 단체 직인이나 대표자의 서명이 날인된 위임장 1부 첨부',
                      )}
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div class="info fake-product">
              <h5>${T('report::② 위조 상품 판매 (상표권/디자인권 침해 상품 관련)')}</h5>
              <div class="note">
                <ul class="article__list">
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T('report::상표권/디자인권 및 해당 셀러의 침해 사실을 증빙할 수 있는 자료 첨부')}
                    </p>
                  </li>
                  <li class="group-li">
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T('report::기업/단체인 경우 사업자등록증, 법인등록증 사본 1부 첨부')}
                    </p>
                  </li>
                  <li class="group-li">
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T(
                        'report::접수자가 단체 대표자가 아닌 경우, 단체 직인이나 대표자의 서명이 날인된 위임장 1부 첨부',
                      )}
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div class="info adult-regulation">
              <h5>${T('report::4 성인 인증 규정 위반')}</h5>
              <div class="note">
                <ul class="article__list">
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T('report::해당 셀러가 성인 인증 규정 위반을 증빙할 수 있는 자료 첨부')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div class="info internal-regulation">
              <h5>${T('report::③ 마플샵 내부 규정 위반 (연령 제한, 타인 명의로 운영 중인 샵 관련)')}</h5>
              <div class="note">
                <ul class="article__list">
                  <li>
                    <div class="article__ellipsis"></div>
                    <p class="article__text">
                      ${T('report::해당 셀러가 마플샵 내부 규정을 위반했음을 증빙할 수 있는 자료 첨부')}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="article">
          <div class="article__sub--title">
            <h2>${T('report::4. 본인 인증')}</h2>
          </div>
          ${MShopAppSolutionCertTmplS.make(true)}
        </div>
      </div>
    `,
  );
